import { render, staticRenderFns } from "./dataDashboard.vue?vue&type=template&id=19815390"
import script from "./dataDashboard.vue?vue&type=script&lang=js"
export * from "./dataDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports